package cc.easyandroid.extensions_compose.mvi


import cc.easyandroid.easycompose.core.instancekeeper.InstanceKeeper
import cc.easyandroid.easycompose.mvi.rx.Disposable
import cc.easyandroid.easycompose.mvi.rx.Observer
import cc.easyandroid.easycompose.mvi.store.Bootstrapper
import cc.easyandroid.easycompose.mvi.store.Executor
import cc.easyandroid.easycompose.mvi.store.Reducer
import cc.easyandroid.easycompose.mvi.store.Store
import cc.easyandroid.easycompose.mvi.store.StoreFactory
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.StateFlow
import kotlin.getValue

//message-action
//action->內部跳轉
//lable->一次性事件
abstract class StoreViewModel<Intent : Any, Action : Any, State : Any, Message : Any, Effect : Any>(
    name: String? = null,
    storeFactory: StoreFactory
) : InstanceKeeper.Instance, Store<Intent, State, Effect> {
    protected abstract val initialState: State
    protected abstract fun onCreatExecutor(): () -> Executor<Intent, Action, State, Message, Effect>
    protected open fun onCreateReducer(): Reducer<State, Message> = Reducer {
        this
    }

    protected open fun onCreateBootstrapper(): Bootstrapper<Action>? = null

    private val store: Store<Intent, State, Effect> by lazy {
        storeFactory.create(
            name = name,
            autoInit = true,
            initialState = initialState,
            bootstrapper = onCreateBootstrapper(),
            executorFactory = onCreatExecutor(),
            reducer = onCreateReducer(),
        )
    }
    override val state: State get() = store.state
    override val isDisposed: Boolean get() = store.isDisposed

    override fun states(observer: Observer<State>): Disposable = store.states(observer)

    override fun labels(observer: Observer<Effect>): Disposable = store.labels(observer)

    override fun accept(intent: Intent) = store.accept(intent)

    override fun init() = store.init()

    @OptIn(ExperimentalCoroutinesApi::class)
    val observeState: StateFlow<State> get() = store.stateFlow
    val sideEffect: Flow<Effect> get() = store.labels

    override fun dispose() = store.dispose()

    override fun onDestroy() {
        super.onDestroy()
        dispose()
    }
}